import DomesticPackages from '../components/DomesticPackages'
import InternationalPackages from '../components/InternationalPackages'
import TrendingPackages from './TrendingPackages'
import HoneymoonPackages from './HoneymoonPackages'
import GroupTourPackages from './GroupTourPackages'
import Breadcrumb from '../components/Breadcrumb'
import { useLocation, useParams } from 'react-router-dom'
import { destinations } from '../data/Destination'
import { useEffect, useRef, useState } from 'react'
import HelmetComponent from '../components/Helmet'

const HolidaysPackages = () => {
    const { slug } = useParams();
    const pkg = destinations?.find((d) => d?.slug === slug);
    const location = useLocation();
    const path = location.pathname;

    const holidaysPackages = useRef(null);

    // 🔥 sections config
    const sections = [
        { id: "trending", label: "Trending Packages", icon: "🏖️" },
        { id: "domestic", label: "India Holiday Packages", icon: "🕌" },
        { id: "international", label: "International Holiday Packages", icon: "🧳" },
        { id: "honeymoon", label: "Honeymoon Packages", icon: "💑" },
        { id: "group", label: "Group Tours", icon: "👨‍👩‍👧‍👦" },
    ];

    const [active, setActive] = useState("trending");

    const scrollToSection = (id) => {
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    const getVariant = (path) => {
        if (path.includes("/packages")) return "packages";
        if (path === "/") return "home";
        return "default";
    };

    // 🔥 auto scroll top on load
    useEffect(() => {
        if (holidaysPackages.current) {
            holidaysPackages.current.scrollIntoView({ behavior: "auto" });
        }
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            let current = "";

            sections.forEach((sec) => {
                const el = document.getElementById(sec.id);
                if (el) {
                    const rect = el.getBoundingClientRect();

                    // 👇 THIS IS THE REAL FIX
                    if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
                        current = sec.id;
                    }
                }
            });

            if (current) setActive(current);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    });

    return (
        <>
            <HelmetComponent
                title="Domestic & International Tour Packages | Shri Radhe Holidays"
                description="Explore trending domestic and international tour packages with Shri Radhe Holidays. Book honeymoon packages, India holiday packages, family vacations, group tours, luxury holidays, adventure trips, customized travel packages, hotel bookings and sightseeing tours at affordable prices."
                image="https://www.shriradheholidays.com/logo2.png"
                url="https://www.shriradheholidays.com/packages"
            />
            <div className='scroll-mt-[90px]' ref={holidaysPackages}>
                {/* 🔥 Scroll Navigation */}
                <div className="max-md:hidden sticky md:top-0 xl:top-[70px] lg:top-[70px] z-40 bg-[#ffffff] rounded-b-full shadow-lg mb-2"
                >
                    <div className="max-w-full  flex items-center justify-evenly  overflow-x-auto no-scrollbar px-4 py-2">
                        {sections.map((item) => (
                            <div
                                key={item.id}
                                onClick={() => scrollToSection(item.id)}
                                className={`flex items-center  gap-1 px-3 py-1 rounded-full cursor-pointer whitespace-nowrap transition
                                ${active === item.id
                                        ? "bg-[#0B1C3D] text-[#ffffff] shadow font-semibold"
                                        : "text-gray-600 hover:bg-white"
                                    }`}
                            >
                                <span className='xl:text-[32px] lg:text-[20px] md:text-[16px]'>{item.icon}</span>
                                <span className='xl:text-[16px] lg:text-[10px] md:text-[8px] hanuman-bold xl:mt-2 lg:mt-2 md:mt-1'>{item.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
                <Breadcrumb
                    title={pkg?.name}
                    destination={pkg?.name}
                    variant={getVariant(path)}
                />
                {/* 🔥 Sections wrapping (IMPORTANT) */}

                <section id="trending" className="scroll-mt-32">
                    <TrendingPackages />
                </section>

                <section id="domestic" className="scroll-mt-32">
                    <DomesticPackages />
                </section>

                <section id="international" className="scroll-mt-32">
                    <InternationalPackages />
                </section>

                <section id="honeymoon" className="scroll-mt-32">
                    <HoneymoonPackages />
                </section>

                <section id="group" className="scroll-mt-32">
                    <GroupTourPackages />
                </section>
            </div>
        </>
    )
}

export default HolidaysPackages;